module.exports = __webpack_public_path__ + "img/classbooking_white.b56c2395.svg";